import { Injectable, Injector } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { FirebaseAuthDriver } from 'src/app/drivers/auth/firebase-auth.driver';
import { LoggedUser } from 'src/app/models/auth/logged-user.model';
import { IAuthDriver } from './drivers/auth-driver.interface';

@Injectable({
  providedIn: 'any'
})
export class AuthService implements IAuthDriver {
  private authDriver: IAuthDriver = null;
  private loggedUser: LoggedUser = null;

  constructor(private injector: Injector) {
  }

  get user(): LoggedUser {
    return this.loggedUser;
  }

  get isLogged() {
    return !!this.user;
  }

  private get driver(): IAuthDriver {
    if (this.authDriver === null) {
      const dependency = this.injector.get(AngularFireAuth);
      this.authDriver = new FirebaseAuthDriver(dependency);
    }

    return this.authDriver;
  }

  getSupportedProviders(): string[] {
    return this.driver.getSupportedProviders();
  }

  async signInWithProvider(provider: string): Promise<LoggedUser> {
    const user = await this.driver.signInWithProvider(provider);
    this.loggedUser = user;
    return user;
  }

  async signInWithEmailAndPassword(email: string, password: string): Promise<LoggedUser> {
    const user = await this.driver.signInWithEmailAndPassword(email, password);
    this.loggedUser = user;
    return user;
  }

  signUp(name: string, email: string, password: string): Promise<LoggedUser> {
    return this.driver.signUp(name, email, password);
  }

  sendPasswordResetEmail(email: string): Promise<any> {
    return this.driver.sendPasswordResetEmail(email);
  }

  async logout(): Promise<any> {
    await this.driver.logout();
    this.loggedUser = null;
  }

  changePassword(currentEmail: string, password: string, newPassword: string): Promise<boolean> {
    return this.driver.changePassword(currentEmail, password, newPassword);
  }

  changeEmail(currentEmail: string, password: string, newEmail: string): Promise<boolean> {
    return this.driver.changeEmail(currentEmail, password, newEmail);
  }
}
